/**
 * 6529.io API
 * This is the API interface description. Brief terminology overview and an authentication example can be found at <a href=\"https://6529.io/about/api\">https://6529.io/about/api</a>.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { ApiCreateNewWaveChatConfig } from '../models/ApiCreateNewWaveChatConfig';
import { ApiCreateNewWaveParticipationConfig } from '../models/ApiCreateNewWaveParticipationConfig';
import { ApiCreateNewWaveVisibilityConfig } from '../models/ApiCreateNewWaveVisibilityConfig';
import { ApiCreateNewWaveVotingConfig } from '../models/ApiCreateNewWaveVotingConfig';
import { ApiCreateWaveConfig } from '../models/ApiCreateWaveConfig';
import { ApiWaveOutcome } from '../models/ApiWaveOutcome';
import { HttpFile } from '../http/http';

export class ApiUpdateWaveRequest {
    /**
    * The name of the wave
    */
    'name': string;
    /**
    * The picture of the wave
    */
    'picture': string | null;
    'voting': ApiCreateNewWaveVotingConfig;
    'visibility': ApiCreateNewWaveVisibilityConfig;
    'participation': ApiCreateNewWaveParticipationConfig;
    'chat': ApiCreateNewWaveChatConfig;
    'wave': ApiCreateWaveConfig;
    'outcomes': Array<ApiWaveOutcome>;

    static readonly discriminator: string | undefined = undefined;

    static readonly mapping: {[index: string]: string} | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "picture",
            "baseName": "picture",
            "type": "string",
            "format": ""
        },
        {
            "name": "voting",
            "baseName": "voting",
            "type": "ApiCreateNewWaveVotingConfig",
            "format": ""
        },
        {
            "name": "visibility",
            "baseName": "visibility",
            "type": "ApiCreateNewWaveVisibilityConfig",
            "format": ""
        },
        {
            "name": "participation",
            "baseName": "participation",
            "type": "ApiCreateNewWaveParticipationConfig",
            "format": ""
        },
        {
            "name": "chat",
            "baseName": "chat",
            "type": "ApiCreateNewWaveChatConfig",
            "format": ""
        },
        {
            "name": "wave",
            "baseName": "wave",
            "type": "ApiCreateWaveConfig",
            "format": ""
        },
        {
            "name": "outcomes",
            "baseName": "outcomes",
            "type": "Array<ApiWaveOutcome>",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return ApiUpdateWaveRequest.attributeTypeMap;
    }

    public constructor() {
    }
}
